/**
 * Unsplash photo search — client-side API call.
 * Requires UNSPLASH_ACCESS_KEY in server env or falls back gracefully.
 * Free tier: 50 requests/hour.
 */
const UNSPLASH_API = 'https://api.unsplash.com';

export async function searchPhotos(query, perPage = 9) {
    let accessKey = window.__unsplashKey;
    if (!accessKey) {
        try {
            const res = await fetch('/api/settings/public-config');
            const data = await res.json();
            accessKey = data?.unsplashKey || '';
            window.__unsplashKey = accessKey;
        } catch(e) {}
    }

    if (!accessKey) {
        throw new Error('Unsplash not configured. Add UNSPLASH_ACCESS_KEY to your .env file.');
    }

    const url = `${UNSPLASH_API}/search/photos?query=${encodeURIComponent(query)}&per_page=${perPage}&orientation=landscape`;
    const res = await fetch(url, {
        headers: { 'Authorization': `Client-ID ${accessKey}` }
    });

    if (!res.ok) throw new Error(`Unsplash API error: ${res.status}`);

    const data = await res.json();
    return (data.results || []).map(photo => ({
        id: photo.id,
        url: photo.urls.regular,
        thumb: photo.urls.small,
        alt: photo.alt_description || photo.description || query,
        author: photo.user.name,
        authorUrl: photo.user.links.html,
        downloadUrl: photo.links.download_location
    }));
}
